export const SLUG_PAGE_DATA = {
  kg: {
    city: 'bishkek',
    title: 'Политика конфиденциальности — Ресторан Farfor в Кыргызстане',
    description:
      'Администрация обязуется использовать персональные данные, полученные в результате использования Сайта в соответствии с требованиями законодательства Кыргызской Республики «Об информации персонального характера» от 14.04.2008 года, за № 58 и постановления Правительства Кыргызской Республики «Об утверждении Требований к обеспечению безопасности и защите персональных данных при их обработке в информационных системах персональных данных, исполнение которых обеспечивает установленные уровни защищенности персональных данных» от 21.11.2017 года за №. 76.',
  },
  com: {
    city: 'uralsk',
    title: 'Политика конфиденциальности — Ресторан Farfor в Казахстане',
    description:
      'Администрация обязуется использовать персональные данные, полученные в результате использования Сайта в соответствии с требованиями законодательства о защите персональных данных, соответствии приказа ,подпунктом 7) пункта 1 статьи 27-1 Закона Республики Казахстан от 21 мая 2013 года "О персональных данных и их защите".',
  },
  ru: {
    city: 'ufa',
    title: 'Политика конфиденциальности — Ресторан Farfor в России',
    description:
      'Настоящая политика Конфиденциальности приложений и сайтов ресторана доставки «Фарфор» действует в отношении всей информации, которую ООО Ресторан «Фарфор» может получить о пользователе во время использования им приложений и сайтов ООО «Фарфор Франчайзинг» и его партнеров.',
  },
}

export const DEFAULT_SLUG_DATA = {
  city: 'ufa',
  title: 'Политика конфиденциальности — Ресторан Farfor в России',
  description:
    'Настоящая политика Конфиденциальности приложений и сайтов ресторана доставки «Фарфор» действует в отношении всей информации, которую ООО Ресторан «Фарфор» может получить о пользователе во время использования им приложений и сайтов ООО «Фарфор Франчайзинг» и его партнеров.',
}
